import {
	mapCoverageAreaTypeFromSysApi,
	mapFragmentFeaturesToModel
} from '@shure/shared/angular/data-access/system-api/mappers';

import { CoverageAudioCoverageArea } from '../../api/models';
import { DeviceCoverageAudioCoverageAreaFragment } from '../graphql/generated/device-coverage-audio-area.generated';

import { SysApiCoverageAreaConstraintsMapper } from './coverage-area-constraints.mapper';
import { SysApiCoverageAreaRectMapper } from './coverage-area-rect.mapper';

export function mapCoverageAudioCoverageAreaFromSysApi(
	fragment: DeviceCoverageAudioCoverageAreaFragment
): CoverageAudioCoverageArea {
	const { configuration, gain, mute } = fragment.features;
	const { constraints, index } = fragment.description;

	return {
		id: fragment.id,
		index,
		description: {
			constraints: {
				gain: SysApiCoverageAreaConstraintsMapper.toConstraints(constraints.gain?.gain?.range)
			}
		},
		features: mapFragmentFeaturesToModel(fragment, {
			configuration: () => ({
				value: {
					active: configuration?.active ?? false,
					area: SysApiCoverageAreaRectMapper.toCoverageAreaRect(configuration?.coordinates),
					constraints: SysApiCoverageAreaConstraintsMapper.toCoverageAreaConstraints(
						configuration?.type,
						constraints.configuration?.type
					),
					type: mapCoverageAreaTypeFromSysApi(configuration?.type)
				}
			}),
			gain: () => ({ value: gain?.gain ?? 0 }),
			muted: { source: 'mute', map: () => ({ value: mute?.muted ?? false }) }
		})
	};
}
